import React from 'react';
import type { Props as GlobalDashboardLayoutProps } from './GlobalDashboardLayout';
import GlobalDashboardLayout from './GlobalDashboardLayout';
import { Nav } from '../pages/RosterManagement/modules';
import { useI18n } from '@whizz/react-i18n';
import Section from '../global/sections/Section';
import { useCleverIntegration } from '../hooks/useCleverIntegration';
import { Alert } from '../components';

interface Props extends Omit<GlobalDashboardLayoutProps, 'icon'> {
  statistics?: React.ReactNode | null;
  disableSection?: boolean;
}

const RosterManagementLayout = (
  {
    children,
    statistics,
    title,
    disableSection = false,
    ...rest
  }: Props,
): JSX.Element => {
  const { translate } = useI18n();
  const [ isClever ] = useCleverIntegration();
  const SectionWrapper = disableSection ? React.Fragment : Section;

  return (
    <GlobalDashboardLayout
      {...rest}
      disableContainer
      title={translate('pages.ROSTER_MANAGEMENT.HEADER')}
      subHeader={<Nav />}
      fullWidthContent
    >
      {isClever ? (
        <Alert
          show
          type={'info'}
          disableIcon={false}
          invert
          dismissable={{ id: 'rm-mis-info' }}
          className={'mb-lg whitespace-pre-wrap'}
        >
          {translate('pages.ROSTER_MANAGEMENT.CLEVER_MANAGED')}
        </Alert>
      ) : null}
      {statistics ? (
        <div className={'mb-4 flex justify-around text-sm italic'}>
          {statistics}
        </div>
      ) : null}
      {title ? (
        <h2 className={'container text-2xl font-bold'}>{title}</h2>
      ) : null}
      <SectionWrapper>
        <div className={'container'}>
          {children}
        </div>
      </SectionWrapper>
    </GlobalDashboardLayout>
  );
};

export default RosterManagementLayout;
